import { LabelLarge } from 'baseui/typography';

import { IMultiState } from './types'
import { OperatorPanelWrapper } from '../../components/Layout'
import { themedUseStyletron } from '../../../theme/customTheme';
import { Badge } from 'baseui/badge';


export const OperatorPanel = (props: IMultiState) => {
  const [, theme] = themedUseStyletron();

  return (

    <OperatorPanelWrapper
      objectId={props.id}
      resourceGroupId={props.resourceGroupId}
      statusContent={<Badge hierarchy='secondary' color='accent' content={props.actStateText} />}
      operationModeContent={<></>}
    >
    </OperatorPanelWrapper>
  )
}  